import script from "./qooBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./qooBtn.vue?vue&type=script&setup=true&lang=js"

import "./qooBtn.vue?vue&type=style&index=0&id=685322a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-685322a0"]])

export default __exports__